<script setup lang="ts">
import ConnxIcon from '../Atoms/ConnxIcon.vue';

interface Props {
  addItem?: (() => void) | null,
  editItem?: (() => void) | null,
  deleteItem?: (() => void) | null,
  saveItem?: (() => void) | null,
}

const cssClasses = 'tw-border tw-border-solid tw-border-connx-grey-tint-70 tw-grow-0 tw-shrink-0 tw-outline-none tw-text-connx-grey tw-rounded-full tw-w-[35px] tw-h-[35px] tw-flex tw-items-center tw-justify-center';

defineProps<Props>();
</script>
<template>
  <Teleport to="#page-header">
    <div class="tw-flex tw-gap-x-4.5">
      <slot></slot>
      <button type="button" v-if="addItem" @click="addItem()" :class="cssClasses"
        class="hover:tw-bg-connx-primary hover:tw-border-connx-primary hover:tw-text-connx-white" aria-label="Add"
        title="Add">
        <connx-icon class="tw-w-auto tw-h-[17px]" name="fas fa-plus"></connx-icon>
      </button>
      <button type="button" v-if="editItem" @click="editItem()" :class="cssClasses"
        class=" hover:tw-bg-connx-grey-tint-70" aria-label="Edit" title="Edit">
        <connx-icon class="tw-w-auto tw-h-[17px]" name="fas fa-pen"></connx-icon>
      </button>
      <button type="button" v-if="deleteItem" @click="deleteItem()" :class="cssClasses"
        class="hover:tw-bg-connx-danger hover:tw-border-connx-danger hover:tw-text-connx-white" aria-label="Delete"
        title="Delete">
        <connx-icon class="tw-w-auto tw-h-[17px]" name="fas fa-trash-alt"></connx-icon>
      </button>
    </div>
  </Teleport>
</template>